import Slider2 from './Slider2'
export default Slider2
